/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

export const AR_MFG_TBL_DATA = 'AR_MFG_TBL_DATA';
export const AR_MFG_FLD_DATA = 'AR_MFG_FLD_DATA';
export const AR_MFG_UNALLOCATED_VAL = 'AR_MFG_UNALLOCATED_VAL';
export const AR_MFG_NDC_DETAIL = 'AR_MFG_NDC_DETAIL';
export const AR_MFG_FIRST_LOAD = 'AR_MFG_FIRST_LOAD';
export const AR_MANUFACTURER_CLEAR_REDUX = 'AR_MANUFACTURER_CLEAR_REDUX';
